import { HttpRequest } from '@lib/http/HttpRequest';

import type { TPayloadValue } from '@endurancewarranty/lib';
import type { TBody } from '@lib/types/THttpRequest';
import type { THttpResponse, THttpResponseOptions, TReturnable } from '@lib/types/THttpResponse';

/**
 * @private Do not use this class directly
 */
export class PostRequest extends HttpRequest {
  constructor(
    endpoint: string,
    tokenTask: () => Promise<Maybe<string>>,
    body?: TBody,
    query?: Record<string, TPayloadValue>,
    headers?: Maybe<Record<string, string>>,
    tokenRefresher?: Maybe<() => Promise<Maybe<string>>>,
  ) {
    super(endpoint);

    this.setMethod('POST');
    this.setTokenFetcher(tokenTask);

    if (tokenRefresher != null) {
      this.setTokenRefresher(tokenRefresher);
    }

    if (body != null) {
      this.setBody(body);
    }

    if (query != null) {
      this.setQuery(query);
    }

    if (headers != null) {
      this.setHeaders(headers);
    }
  }

  public override async send<T extends TReturnable>(
    responseOptions?: Maybe<THttpResponseOptions>,
  ): Promise<THttpResponse<T>> {
    return await super.send(responseOptions);
  }
}
